export class AbandonedMine {
    jurisdiction: string;
    abandoned_mine_identifier: string;
    official_name: string;
    mine_site_status_code: string;
    mine_closure_reason: string;
    operational_access: string;
    closure_plan: string;
    mine_plan_or_section: string;
    progressive_rehab_plan: string;
    amis_district_description: string;
    mndm_township_area_name: string;
    lot_number: string;
    concession_number: string;
    utm_zone: string;
    utm_northing: string;
    utm_easting: string;
    latitude_decimal_degrees: string;
    longitude_decimal_degrees: string;
    nts_number: string;
    date_mineopened: string;
    date_mineclosed: string;
    mdi_identifier_old:string;
    mdi_identifier_new: string;
    primary_commodity: string;
    mine_site_class: string;
    date_lastmodified: string;
    features: any[] = [];
    alt_name: any[] = [];
    division: any[] = [];
  
    constructor(init?: Partial<AbandonedMine>) {
      Object.assign(this, init);
    }
  }

 